<template>
  <div id="app">
    <Header />
    <main class="main-content">
      <router-view v-slot="{ Component }">
        <transition name="page" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </main>
    <SiteFooter />
    <MousePointerComp />
  </div>
</template>

<script>
import Header from '@/layout/Header.vue'
import SiteFooter from '@/layout/Footer.vue'
import MousePointerComp from '@/components/MousePointerComp.vue'

export default {
  name: 'App',
  components: {
    Header,
    SiteFooter,
    MousePointerComp
  }
}
</script>

<style>
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  margin-top: 70px; /* Height of the header */
  min-height: calc(100vh - 80px - 400px); /* viewport height - header - footer */
  background-color: var(--white);
}

@media (max-width: 768px) {
  .main-content {
    margin-top: 60px;
    min-height: calc(100vh - 60px - 600px);
  }
}

/* Global styles */
:root {
  /* Primary Colors from Logo */
  --sogdo-purple: #8A2BE2;
  --sogdo-pink: #E91E63;
  --sogdo-black: #000000;
  --sogdo-white: #FFFFFF;
  
  /* Gradient */
  --sogdo-gradient: linear-gradient(135deg, var(--sogdo-purple), var(--sogdo-pink));
  
  /* Functional Colors */
  --primary-color: var(--sogdo-purple);
  --secondary-color: var(--sogdo-pink);
  --background-dark: var(--sogdo-black);
  --text-light: var(--sogdo-white);
  
  /* Additional UI Colors */
  --background-light: #F8F9FA;
  --text-dark: #0B2B3C;
  --text-muted: #718096;
  --border-color: #E2E8F0;
}

body {
  background-color: #0E0E0E;
  color: var(--text-light);
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Router view should take up remaining space */
router-view {
  flex: 1;
}

/* Global link styles */
a {
  color: var(--primary-color);
  text-decoration: none;
  transition: color 0.3s ease;
}

a:hover {
  color: var(--primary-dark);
}

/* Global button styles */
button {
  background-color: var(--primary-color);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
}

button:hover {
  background-color: var(--primary-dark);
  transform: translateY(-2px);
}
</style> 